import styled from 'styled-components';
import { COLORS } from '../../../websiteLandingPages/styles/Theme';
import { DEVICES } from '../../config/appConfig';

export const SuccessStyledContainer = styled.div`
  background-color: rgb(27, 25, 24);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .flexStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
  }
`;

export const SuccessImgStyle = styled.div`
  .imgStyle {
    width: 120px;
  }
`;
export const ContentStyle = styled.div`
  text-align: center;
  h5 {
    font-size: 20px;
    font-weight: 500;
    color: ${COLORS.WHITE};
  }
  h2 {
    font-size: 32px;
    font-weight: 600;
    color: ${COLORS.PRIMARY};
  }
  @media ${DEVICES.tablet} {
    h5 {
      font-size: 18px;
      font-weight: 500;
      color: ${COLORS.WARM_AMBER};
    }
    h2 {
      font-size: 30px;
      font-weight: 600;
      color: ${COLORS.PRIMARY};
    }
  }
  @media ${DEVICES.mobile} {
    h5 {
      font-size: 16px;
      font-weight: 500;
      color: ${COLORS.WARM_AMBER};
    }
    h2 {
      font-size: 28px;
      font-weight: 600;
      color: ${COLORS.PRIMARY};
    }
  }
  @media ${DEVICES.sMobile} {
    h5 {
      font-size: 14px;
      font-weight: 500;
      color: ${COLORS.WARM_AMBER};
    }
    h2 {
      font-size: 24px;
      font-weight: 600;
      color: ${COLORS.PRIMARY};
    }
  }
`;
export const RedirectSection = styled.div`
  text-align: center;
  padding: 14px 20px;
  border: 1px solid #b0b0b0;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  h2 {
    font-size: 12px;
    font-weight: 500;
    color: ${COLORS.WHITE};
    text-align: center;
  }
  .linkSection {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }
  .linkStyle {
    font-size: 14px;
    font-weight: 600;
    color: ${COLORS.PRIMARY};
    text-align: center;
    text-decoration: none;
  }
  @media ${DEVICES.tablet} {
    h2 {
      font-size: 12px;
      font-weight: 500;
      color: ${COLORS.WHITE};
      text-align: center;
    }
    .linkStyle {
      font-size: 14px;
      font-weight: 600;
      color: ${COLORS.PRIMARY};
      text-align: center;
      text-decoration: none;
    }
  }
  @media ${DEVICES.mobile} {
    h2 {
      font-size: 10px;
      font-weight: 500;
      color: ${COLORS.WHITE};
      text-align: center;
    }
    .linkStyle {
      font-size: 12px;
      font-weight: 600;
      color: ${COLORS.PRIMARY};
      text-align: center;
      text-decoration: none;
    }
  }
  @media ${DEVICES.sMobile} {
    h2 {
      font-size: 10px;
      font-weight: 500;
      color: ${COLORS.WHITE};
      text-align: center;
    }
    .linkStyle {
      font-size: 10px;
      font-weight: 600;
      color: ${COLORS.PRIMARY};
      text-align: center;
      text-decoration: none;
    }
  }
`;
